<div class="section-redirect">
  <br/>
  <br/>
  <br/>

  <div class="container">
    <div class="row">
      <div class="col">
        <div class="text-center">
          <span class="spinner-border"></span>
        </div>
      </div>
    </div>
  </div>

  <br/>
  <br/>
  <br/>
</div>
